<template>
	<div class="indexBox">
		<div class="banner">
			<div class="swiper" id="bannerSwiper">
				<div class="swiper-wrapper">
					<div class="swiper-slide " v-for="item in bannerList"
						:style="{'backgroundImage':'url('+item.imageUrl+')'}" @click="clickUrl(item)" >
						<div class="name">{{item.title}}</div>
					</div>
				</div>
			<div class="swiper-pagination"></div>
			</div>
			
		</div>
		<ul class="goodsList flexBox">
			<li v-for="(item,idx) in goodsList" @click="clickGoods(item)">
				<div class="name">
					{{item.name}}
				</div>
				<div class="box">
					<div class="txt">
						<i class="tag"></i>
						<em>处理器</em><span>{{item.processor}}</span>
					</div>
					<div class="txt">
						<i class="tag"></i>
						内　　存<span>{{item.memory}}</span>
					</div>
					<div class="txt">
						<i class="tag"></i>
						存　　储<span>{{item.storage}}</span>
					</div>
					<div class="txt">
						<i class="tag"></i>
						<em style="letter-spacing: 1.2rem;">GPU</em><span
							style="margin-left: 0;">{{item.gpuTypeName}}*{{item.quantity}}</span>
					</div>
					<div class="val">
						¥<span>{{item.discountPrice}}</span>/{{item.unit}}
					</div>
					<div class="count">
						<span>{{item.originalPrice}}</span>/{{item.unit}}
					</div>
				</div>
			</li>
		</ul>

		<div class="serveBox" v-if="serveList.imageUrl" :style="{'backgroundImage':'url('+serveList.imageUrl+')'}">
			<div class="tag">{{serveList.subtitle}}</div>
			<div class="name">{{serveList.categoryName}}</div>
			<div class="des">{{serveList.content}}</div>
			<router-link to="/solution" class="more">了解详情<a-icon type="arrow-right" class="icon" /></router-link>
		</div>

		<div class="explainBox">
			<div class="swiper" id="explainSwiper">
				<div class="swiper-wrapper">
					<div class="swiper-slide row" v-for="item in explain"
						:style="{'backgroundImage':'url('+item.imageUrl+')'}">
						<div class="flexBox title">
							<img src="../../../assets/img/lib/logo.png" class="icon">
							<i class="line"></i>
							<div class="txt">{{item.title}}</div>
						</div>
						<div class="des" v-html="item.content" style="overflow-wrap: anywhere;word-break:normal"></div>
						<router-link v-if="item.linkUrl" :to="'/'+item.linkUrl" class="more" @click="clickExplain(item)">了解详情<a-icon type="arrow-right" class="icon" /></router-link>
						<router-link v-else to="" class="more" @click="clickExplain(item)">了解详情<a-icon type="arrow-right" class="icon" /></router-link>
					</div>
				</div>
				<div class="swiper-pagination"></div>
			</div>
		</div>

<!--		<div class="infoBox">-->
<!--			<div class="title flexBox">-->
<!--				<div class="name">新闻资讯</div>-->
<!--				<ul class="tabList flexBox">-->
<!--					<li v-for="(item,idx) in newTab" :class="newTabIdx == idx ? 'active' : ''" @click="clickNew(idx)">-->
<!--						{{item.name}}-->
<!--					</li>-->
<!--				</ul>-->
<!--			</div>-->
<!--			<ul class="listBox">-->
<!--				<li v-for="(item,idx) in newList"-->
<!--					:style="{'backgroundImage':'url('+ require('../../../assets/img/index/new_'+idx+'.png')+')'}">-->
<!--					<div class="box">-->
<!--						<div class="time">{{item.publishTime}}</div>-->
<!--						<div class="name" v-html="item.title" style="white-space: pre-wrap;"></div>-->
<!--						<a class="more" @click="clickNewDes(item)">-->
<!--							了解详情<a-icon type="arrow-right" class="icon" />-->
<!--						</a>-->
<!--					</div>-->
<!--				</li>-->
<!--			</ul>-->
<!--			<router-link to="/new" class="look">了解更多新闻资讯 <a-icon type="right-circle" class="icon" /></router-link>-->
<!--		</div>-->

		<div class="coopBox">
			<div class="name">合作伙伴</div>
			<div class="swiperBox">
				<div class="swiper" id="coopSwiper">
					<div class="swiper-wrapper">
						<div class="swiper-slide row" v-for="item in coop" @click="clickCoop(item)">
							<img :src="item.logoUrl">
						</div>
					</div>
					<div class="swiperNext posCenterY">
						<img src="../../../assets/img/index/left.png">
					</div>
					<div class="swiperPrev posCenterY">
						<img src="../../../assets/img/index/right.png">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper, {
		Autoplay,
		Grid,
		Navigation,
		Pagination
	} from 'swiper';
	Swiper.use([Autoplay, Grid, Navigation, Pagination]);
	export default {
		name: 'Index',
		components: {
			Navigation
		},
		data() {
			return {
				bannerList: [],
				goodsList: [],
				explain: [],
				serveList: [],
				newTab: [],
				newTabIdx: 0,
				newList: [],
				coop: []
			}
		},
		mounted() {
			this.getData();
		},
		methods: {
			getData() {
				this.$req("get", "/api/cms/banner/listByCode/index_banner").then((res) => {
					this.bannerList = res.data;
					this.updateBanner();
				});

				this.$req("get", "/api/cms/partner/list").then((res) => {
					this.coop = res.data;
					this.updateCoop()
				});

				this.$req("get", "/api/cms/news/categories").then((res) => {
					this.newTab = res.data;
					this.updateList()
				});

				this.$req("get", "/api/cms/banner/listByCode/index_three").then((res) => {
					this.explain = res.data;
					this.updateExplain();
				});
				this.$req("get", "/api/cms/bannerCategory/getByCode/index_slqd").then((res) => {
					this.serveList = res.data;
				});

				this.$req("get", "/api/cms/product/list", {
					params: {
						pageNum: 1,
						pageSize: 4,
						recommend: 1
					}
				}).then((res) => {
					this.goodsList = res.rows;
				});
			},
			clickGoods(item) {
				this.$tools.checkLoginAndJump(item.productTypeLink);
			},
			updateList() {
				this.$req("get", "/api/cms/news/pageList", {
					params: {
						categoryId: this.newTab[this.newTabIdx].id,
						pageNum: 1,
						pageSize: 4,
					}
				}).then((res) => {
					this.newList = res.rows;
				});
			},
			updateBanner() {
				new Swiper('#bannerSwiper', {
					loop: true,
					autoplay: {
						delay: 3000,
						disableOnInteraction: false
					},
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					},
				})
			},
			clickNew(idx) {
				this.newTabIdx = idx;
				this.updateList()
			},
			updateExplain() {
				new Swiper('#explainSwiper', {
					loop: true,
					autoplay: {
						delay: 3000,
						disableOnInteraction: false
					},
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
						renderBullet: (index, className) => {
							const item = this.explain[index];
							return '<span class="icon ' + className + '"><i class="tag" style="background-image:url('+item.iconUrl+')"></i>' + this.explain[
								index].title + "</span>";
						},
					},
				})
			},
			updateCoop() {
				new Swiper('#coopSwiper', {
					slidesPerView: 4,
					grid: {
						fill: 'row',
						rows: 2,
					},
					navigation: {
						nextEl: '.swiperPrev',
						prevEl: '.swiperNext',
					}
				})
			},
			clickNewDes(item) {
				this.$router.push({
					path: "/newDes",
					query: {
						id: item.id
					}
				})
			},
			clickCoop(item) {
				if (item.websiteUrl) {
					window.open(item.websiteUrl);
				}
			},
			clickUrl(item) {
				if (item.linkUrl) {
					window.open(item.linkUrl);
				}
			},
			clickExplain(item){
				if(item.linkUrl){
					this.$router.push({
						path: "/"+item.linkUrl,
						query: {
							id: item.id
						}
					})
				}
				
				
			}
		}
	}
</script>

<style scoped>
	@import url("../../../assets/css/portal/index.css");
</style>